import { findSelectedAddress, storeChanged } from './addressUtility';

export default class IdObserver {
	constructor(storeInstance, hiddenFieldName = '', editFieldDataId = '') {
		this.hiddenFieldName = hiddenFieldName;
		this.editFieldDataId = editFieldDataId;

		if (
			storeInstance &&
			typeof storeInstance === 'object' &&
			typeof storeInstance.subscribe === 'function'
		) {
			storeInstance.subscribe(this.storeChanged.bind(this));
		}
	}

	storeChanged(event) {
		storeChanged(event, [
			this.updateHiddenFieldValue.bind(this),
			this.updateEditButtonValue.bind(this),
		]);
	}

	updateHiddenFieldValue(addresses) {
		const selectedAddress = findSelectedAddress(addresses);
		const element = document.querySelector(`[name="${this.hiddenFieldName}"]`);
		if (element) {
			const { value } = element;
			element.value = selectedAddress ? selectedAddress.id : value;
		}
	}

	updateEditButtonValue(addresses) {
		const elements = document.querySelectorAll(
			`[data-id="${this.editFieldDataId}"]`,
		);
		const selectedAddress = findSelectedAddress(addresses);

		if (elements.length > 0 && selectedAddress) {
			elements.forEach(element =>
				element.setAttribute(
					'href',
					`${element.getAttribute('href').split('=')[0]}=${selectedAddress.id}`,
				),
			);
		}
	}
}
